import {CommonActions, NavigationState} from '@react-navigation/native';
import {Screens} from './model';

const getTabsState = (state: NavigationState | undefined): NavigationState | undefined => {
  if (!state) return undefined;
  if (state.routeNames?.includes(Screens.Profile) && state.routeNames?.includes(Screens.Main)) {
    return state;
  }
  const focused = state.routes[state.index];
  return focused?.state ? getTabsState(focused.state as NavigationState) : undefined;
};

export const openTabRoot = (navigation: any, tabName: string) => {
  const tabsState = getTabsState(navigation.getState());
  if (!tabsState) {
    navigation.dispatch(CommonActions.navigate({name: Screens.MainTabs, params: {screen: tabName}}));
    return;
  }

  const tabIndex = tabsState.routes.findIndex((route) => route.name === tabName);
  if (tabIndex < 0) {
    navigation.dispatch(CommonActions.navigate({name: tabName}));
    return;
  }

  navigation.dispatch({
    ...CommonActions.reset({
      ...tabsState,
      index: tabIndex,
      routes: tabsState.routes.map((route) => (route.name === tabName ? {key: route.key, name: route.name} : route)),
    }),
    target: tabsState.key,
  });
};
